var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFunds(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.004 8C53.31 8 56 10.69 56 13.996V50.004C56 53.31 53.31 56 50.004 56H13.996C10.69 56 8 53.31 8 50.004V13.996C8 10.69 10.69 8 13.996 8H50.004ZM50.004 12H13.996C12.896 12 12 12.896 12 13.996V50.004C12 51.106 12.896 52 13.996 52H50.004C51.104 52 52 51.106 52 50.004V13.996C52 12.896 51.104 12 50.004 12ZM21 39C22.656 39 24 40.344 24 42C24 43.656 22.656 45 21 45C19.344 45 18 43.656 18 42C18 40.344 19.344 39 21 39ZM46 40V44H28V40H46ZM21 29C22.656 29 24 30.344 24 32C24 33.656 22.656 35 21 35C19.344 35 18 33.656 18 32C18 30.344 19.344 29 21 29ZM46 30V34H28V30H46ZM21 19C22.656 19 24 20.344 24 22C24 23.656 22.656 25 21 25C19.344 25 18 23.656 18 22C18 20.344 19.344 19 21 19ZM46 20V24H28V20H46Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFunds);
export default __webpack_public_path__ + "static/media/funds.1fd86a25fe3d06e47d975ef94d224db1.svg";
export { ForwardRef as ReactComponent };